const messagingInstance = {
  getToken: async () => 'web-fcm-token',
  onMessage: () => () => {},
  onNotificationOpenedApp: () => () => {},
  getInitialNotification: async () => null,
  setBackgroundMessageHandler: () => {},
  requestPermission: async () => 1,
  hasPermission: async () => 1,
  registerDeviceForRemoteMessages: async () => {},
  setAutoInitEnabled: async () => {},
  AuthorizationStatus: {
    NOT_DETERMINED: -1,
    DENIED: 0,
    AUTHORIZED: 1,
    PROVISIONAL: 2,
  },
};

const messaging = () => messagingInstance;
messaging.getMessaging = messaging;
messaging.AuthorizationStatus = messagingInstance.AuthorizationStatus;

module.exports = messaging;
module.exports.default = messaging;
module.exports.getMessaging = messaging;
module.exports.AuthorizationStatus = messagingInstance.AuthorizationStatus;
